import { useContext } from 'react';
import { ApprovalsContext } from '../Approvals.provider';

export default function useStatusByService(service) {
  const context = useContext(ApprovalsContext);

  const {
    markServiceAsApproved,
    markServiceAsDeclined,
    servicesCheckedStatus,
  } = context;

  const status = servicesCheckedStatus[service.vendorOrderServiceId];
  const _markServiceAsApproved = () =>
    markServiceAsApproved(service.vendorOrderServiceId);
  const _markServiceAsCancelled = () =>
    markServiceAsDeclined(service.vendorOrderServiceId);

  return {
    status,
    markServiceAsApproved: _markServiceAsApproved,
    markServiceAsDeclined: _markServiceAsCancelled,
  };
}
